module.exports = __webpack_public_path__ + "static/img6-301b4cdc2345a0869f6416ce97b23f86.jpg";